export default "__VITE_ASSET__CAILvONG__"